import React from "react";
import { Helmet } from "react-helmet";

const Meta = ({ title, description, keywords }) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
    </Helmet>
  );
};

Meta.defaultProps = {
  title: "Welcome To Ayalo",
  description: "We provide the best service for cheap",
  keywords:
    "Rent your event planning materials such as, canopy, chair, table, hall, generator, drumset, etc. Event decoration, book an apartment, rent a room, hire vehicle.",
};

export default Meta;
